import React, { useCallback, useEffect, useState } from 'react'
import Aditya from '../../images/AboutUs/AdityaDoodle.svg'
import Anurag from '../../images/AboutUs/AnuragDoodle.svg'
import cost from '../../images/AboutUs/cost.svg'
import delivery from '../../images/AboutUs/delivery.svg'
import end from '../../images/AboutUs/end.svg'
import ink from '../../images/AboutUs/ink.svg'
import linkedin from '../../images/AboutUs/linkedin.svg'
import mail from '../../images/AboutUs/mail.svg'
import quality from '../../images/AboutUs/quality.svg'
import start from '../../images/AboutUs/start.svg'
import twitter from '../../images/AboutUs/twitter.svg'
import styles from './AboutUs.module.css'
import Spinner from '../Spinner/Spinner'

function AboutUs() {
  document.title = 'Hustlemad | About Us'
  const [teamMembers, setTeamMembers] = useState([])
  const [loading, setLoading] = useState(true)
  const getTeamMembers = useCallback(async () => {
    setLoading(true)
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL}/team`
      const response = await fetch(url)
      const json = await response.json()
      setTeamMembers(json?.members || [])
      console.log(json)
    } catch (error) {
      console.log(error)
      setTeamMembers([])
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    getTeamMembers()
  }, [getTeamMembers])

  if (loading) {
    return <Spinner />
  }
  return (
    <>
      <div className={styles.AboutUs}>
        <div className={styles.upperpart}>
          {/* <h1 className={styles.heading}>We Love Swag!</h1> */}
          <div class={styles.img}>{/* <img src={claps} alt="Claps" /> */}</div>
        </div>
        <h2 className={styles.subheading}>Our Story</h2>
        <img src={ink} alt='INK' className={styles.ink}></img>
        <div className={styles.storycontent}>
          <div className={styles.startcolon}>
            <img src={start} alt='Start' />
          </div>
          <div className={styles.content}>
            What pains us the most is poor quality swag, it’s not only a waste
            of money but also harms the brand image. Whether you are trying to
            attract the best talent or wow your clients, thoughtful swag goes a
            long way in establishing your commitment to settle for nothing but
            the best.
            <br />
            <br />
            Today, while we have figured out how to send rockets to Mars,
            procuring branded swag continues to be a hassle, even for large
            companies. We have taken it upon ourselves to be your procurement
            partners. Think of us as your extended arm that curates, procures,
            packs & ships quality swag where you need it when you need it.
            <br />
            <br />
            We are a bunch of entrepreneurs, marketers, and technologists who
            understand the challenges of a growing business. We get you the best
            swag while you focus on doing what you do the best!
          </div>
          <div className={styles.endcolon}>
            <img src={end} alt='End' />
          </div>
        </div>
        <div className={styles.corevalues}>
          <h1 className={styles.coreheading}>What drives us</h1>
          <h2 className={styles.coresubheading}>
            Our core values guide everything we do
          </h2>
          <div className={styles.values}>
            <div className={styles.quality}>
              <img src={quality} alt='Quality'></img>
              <h1>Quality</h1>
              <p>
                Quality swag is a great culture enabler in a company. It not
                just delights your team but also inspires them to be
                #BetterEveryday.{' '}
              </p>
            </div>
            <div className={styles.delivery}>
              <img src={delivery} alt='Delivery'></img>
              <h1>Delivery</h1>
              <p>
                We are not a vendor, we are your partner in growth. We
                effectively manage end-to-end procurement operations to keep you
                lean.
              </p>
            </div>
            <div className={styles.cost}>
              <img src={cost} alt='Cost'></img>
              <h1>Cost</h1>
              <p>
                We save hundreds of your human hours that go in the mundanity of
                swag design, curation, procurement, storage & distribution.
              </p>
            </div>
          </div>
        </div>
        <div className={styles.team}>
          <h1 className={styles.teamheading}>Our Team</h1>
          <div className={styles.teammembers}>
            {teamMembers.map((member, index) => {
              return (
                <div className={styles.teams} key={index}>
                  <div class={styles.dot}></div>
                  <h4 class={styles.lead}>{member.position}</h4>
                  <div className={styles.one}>
                    <img src={member.image} class={styles.admin} />
                    <div className={styles.admindesc}>
                      <p>{member.description}</p>
                      <span className={styles.social}>
                        {member.twitter && (
                          <a href={member.twitter} target='_blank'>
                            <img src={twitter} alt='Twitter'></img>
                          </a>
                        )}
                        {member.linkedin && (
                          <a href={member.linkedin} target='_blank'>
                            <img src={linkedin} alt='Linkedin'></img>
                          </a>
                        )}
                        {member.mail && (
                          <a href={`mailto:${member.mail}`} target='_blank'>
                            <img src={mail} alt='Mail'></img>
                          </a>
                        )}
                      </span>
                    </div>
                  </div>

                  <h5 class={styles.member}>{member.name}</h5>
                </div>
              )
            })}

            {/* <div className={styles.teams}>
              <div class={styles.dot}></div>
              <h4 class={styles.lead}>Co-founder</h4>
              <div className={styles.one}>
                <img src={Vipul} class={styles.admin} />
                <div className={styles.admindesc}>
                  <p>
                    Curious Stargazer. Based in a Tier-3 town & a 3rd generation
                    Education entrepreneur, Vipul loves to talk about education,
                    communities, events, philosophy & building for Bharat.
                  </p>
                  <span className={styles.social}>
                    <a href="https://twitter.com/vipulgarg9" target="_blank">
                      <img src={twitter} alt="Twitter"></img>
                    </a>
                    <a
                      href="https://www.linkedin.com/in/vipul9/"
                      target="_blank"
                    >
                      <img src={linkedin} alt="Linkedin"></img>
                    </a>
                    <a href="mailto:vipul@hustlemad.com" target="_blank">
                      <img src={mail} alt="Mail"></img>
                    </a>
                  </span>
                </div>
              </div>

              <h5 class={styles.member}>Vipul Garg</h5>
            </div> */}
            {/* <div className={styles.teams}>
              <div class={styles.dot}></div>
              <h4 class={styles.lead}>Head of Content & Community</h4>
              <div className={styles.one}>
                <img src={Sonam} class={styles.admin} />
                <div className={styles.admindesc}>
                  <p>
                    A dreamer, a do-er, Sonam is a mathematician turned poetic
                    copywriter. Reach out to her and you'll either get solutions
                    or sarcasm.
                  </p>
                  <span className={styles.social}>
                    <a href="https://twitter.com/heycopygirl" target="_blank">
                      <img src={twitter} alt="Twitter"></img>
                    </a>
                    <a
                      href="https://www.linkedin.com/in/sonam-g"
                      target="_blank"
                    >
                      <img src={linkedin} alt="Linkedin"></img>
                    </a>
                    <a href="mailto:sonam@hustlemad.com" target="_blank">
                      <img src={mail} alt="Mail"></img>
                    </a>
                  </span>
                </div>
              </div>
              <h5 class={styles.member}>Sonam</h5>
            </div> */}
            {/* <div className={styles.teams}>
              <div class={styles.dot}></div>
              <h4 class={styles.lead}>Product Designer</h4>
              <div className={styles.one}>
                <img src={Abhinav} class={styles.admin} />
                <div className={`${styles.admindesc} ${styles.us}`}>
                  <p>I designed this entire Website.</p>
                  <span className={styles.social}>
                    <a href="https://twitter.com/creativedumbo" target="_blank">
                      <img src={twitter} alt="Twitter"></img>
                    </a>
                    <a
                      href="https://www.linkedin.com/in/creativedumbo/"
                      target="_blank"
                    >
                      <img src={linkedin} alt="Linkedin"></img>
                    </a>
                    <a href="mailto:creativedumbo11@gmail.com" target="_blank">
                      <img src={mail} alt="Mail"></img>
                    </a>
                  </span>
                </div>
              </div>
              <h5 class={styles.member}>Abhinav Prakash</h5>
            </div> */}
            {/* <div className={styles.teams}>
              <div class={styles.dot}></div>
              <h4 class={styles.lead}>Front-End Developer</h4>
              <div className={styles.one}>
                <img src={Tarun} class={styles.admin} />
                <div className={`${styles.admindesc} ${styles.us}`}>
                  <p>I developed this entire Website.</p>
                  <span className={styles.social}>
                    <a href="#" target="_blank">
                      <img src={twitter} alt="Twitter"></img>
                    </a>
                    <a
                      href="https://www.linkedin.com/in/tarun-thakur-753b6a18b/"
                      target="_blank"
                    >
                      <img src={linkedin} alt="Linkedin"></img>
                    </a>
                    <a href="mailto:tarun@hustlemad.com" target="_blank">
                      <img src={mail} alt="Mail"></img>
                    </a>
                  </span>
                </div>
              </div>

              <h5 class={styles.member}>Tarun Thakur </h5>
            </div> */}
            {/* <div className={styles.teams}>
              <div class={styles.dot}></div>
              <h4 class={styles.lead}>Full-Stack Developer</h4>
              <div className={styles.one}>
                <img src={Rahul} class={styles.admin} />
                <div className={`${styles.admindesc} ${styles.us}`}>
                  <p>I am maintaing this entire Website.</p>
                  <span className={styles.social}>
                    <a href="https://twitter.com/RahulDh24340599" target="_blank">
                      <img src={twitter} alt="Twitter"></img>
                    </a>
                    <a
                      href="https://www.linkedin.com/in/rahul-dhakar-0213ab1b8/"
                      target="_blank"
                    >
                      <img src={linkedin} alt="Linkedin"></img>
                    </a>
                    <a href="rdhakar288@gmail.com" target="_blank">
                      <img src={mail} alt="Mail"></img>
                    </a>
                  </span>
                </div>
              </div>
              <h5 class={styles.member}>Rahul Dhakar </h5>
            </div> */}
            {/* <div className={styles.teams}>
              <div class={styles.dot}></div>
              <h4 class={styles.lead}>Full-Stack Developer</h4>
              <div className={styles.one}>
                <img src={AdityaB} class={styles.admin} />
                <div className={`${styles.admindesc} ${styles.us}`}>
                  <p>
                    I developed this entire Website.
                  </p>
                  <span className={styles.social}>
                    <a href="#" target="_blank">
                      <img src={twitter} alt="Twitter"></img>
                    </a>
                    <a
                      href="https://www.linkedin.com/in/aditya-budhia-3390591bb/"
                      target="_blank"
                    >
                      <img src={linkedin} alt="Linkedin"></img>
                    </a>
                    <a href="mailto:ab@hustlemad.com" target="_blank">
                      <img src={mail} alt="Mail"></img>
                    </a>
                  </span>
                </div>
              </div>
              <h5 class={styles.member}>Aditya Budhia</h5>
            </div> */}
          </div>
        </div>
      </div>
    </>
  )
}

export default AboutUs
